import request from './client'

export interface SocialMediaCommand {
  id: string
  name: string
  content?: string
  folderId?: string | null
  createdAt: string
  updatedAt: string
}

export interface SocialMediaCommandFolder {
  id: string
  name: string
  parentId: string | null
  createdAt: string
  updatedAt: string
}

export interface FolderTreeNode extends SocialMediaCommandFolder {
  children: FolderTreeNode[]
}

export async function getSocialMediaCommands(keyword?: string, folderId?: string): Promise<SocialMediaCommand[]> {
  const params: Record<string, string> = {}
  if (keyword) params.keyword = keyword
  if (folderId !== undefined) params.folderId = folderId
  return request.get('/social-commands', { params: Object.keys(params).length > 0 ? params : undefined })
}

export async function createSocialMediaCommand(data: { name: string; content?: string; folderId?: string }): Promise<SocialMediaCommand> {
  return request.post('/social-commands', data)
}

export async function updateSocialMediaCommand(
  id: string,
  data: { name?: string; content?: string; folderId?: string },
): Promise<SocialMediaCommand> {
  return request.patch(`/social-commands/${id}`, data)
}

export async function deleteSocialMediaCommand(id: string): Promise<void> {
  return request.delete(`/social-commands/${id}`)
}

// ======= Folders =======

export async function getFolderTree(): Promise<FolderTreeNode[]> {
  return request.get('/social-commands/folders/tree')
}

export async function getFolders(): Promise<SocialMediaCommandFolder[]> {
  return request.get('/social-commands/folders')
}

export async function createFolder(data: { name: string; parentId?: string }): Promise<SocialMediaCommandFolder> {
  return request.post('/social-commands/folders', data)
}

export async function updateFolder(id: string, data: { name?: string; parentId?: string }): Promise<SocialMediaCommandFolder> {
  return request.patch(`/social-commands/folders/${id}`, data)
}

export async function deleteFolder(id: string): Promise<void> {
  return request.delete(`/social-commands/folders/${id}`)
}
